import React from 'react';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import {createFilter} from 'react-search-input';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { fetchConsultants , fetchConsultantsInfos, getExportConsultantsList } from '../../actions/consultant';
import ConsultantList from './ConsultantList';
import ConsultantSearch from './ConsultantSearch';

import ContainerTranslation from "../partials/ContainerTranslation";
import SeniorityPyramid from '../dataviz/SeniorityPyramid';
import Map from "../dataviz/Map"


function updateFilter(filter){

  const action = "update_filter"
  function fct(action,filter,dispatch){
    dispatch({type: action,payload:filter})
  }
  return dispatch => fct(action,filter,dispatch);
}

function readFilter(){
  const action = "read_filter"
  function fct(action,dispatch){
    dispatch({type: action})
  }
  return dispatch => fct(action,dispatch);

}

class Consultant extends React.Component {

  constructor(props) {
    super(props);
      const { fetchConsultants } = this.props;
      this.user = JSON.parse(localStorage.getItem("user"))
    fetchConsultants();

    this.state = {
      filtersByOr: [],
      searchTerm: '',
      consultantInfos: {},
      consultants : [],
      sortBy : 'alphabetic',
      validationFilter : 'all',
      filterApplied: true,
      expertiseFilter : {
        'tools':['basic','limited','intermediate','advanced','expert'],
        'engineering':['basic','limited','intermediate','advanced','expert'],
        'expertise':['basic','limited','intermediate','advanced','expert'],
          'intervention-level': ['basic', 'limited', 'intermediate', 'advanced', 'expert'],
          'certification-body': ["signatory under mentorship", "assessor under mentorship", "signatory", "assessor", "lead assessor"],
          "inspection-body": ["assessor under mentorship", "assessor", "lead assessor/technical manager"],
          "non-accredited-services": ["technical manager", "signatory", "assessor", "lead assessor"]
      },
      selectedItems : this.props.filter ? this.props.filter :  {
        'information-consultant':{
          'filiale-country':[],
          'office':[],
          'manager':[]
        },
        'school':{
          'school-name':[],
          'school-year':[],
          'school-diplome':[]
        },
        'formation':{
          'formation-name':[]
        },
        'language':{
          'language-name':[],
          'language-test':[],
          'language-result':[]
        },
        'certification':{
          'certification-name':[],
          'certification-organisme':[]
        },
        'environnement':{
          'environnement-domain':[],
          'environnement-context':[]
        },
        'tools':{
          'name' : []
        },
        'intervention-level':{
          'intervention-type':[],
          'intervention-mission':[],
          'intervention-application':[]
        },
        'expertise':{
          'domain-competence':[],
          'domain-speciality':[],
          'domain-specificity':[],
          'domain-other':[]
          },
        'engineering':{
          'engineering-skill':[],
          'engineering-specialization' : [],
        },
        'clients':[],
      }
      }


  }

  componentDidMount(){

    if (this.user.group === "aegis") {
      this.setState({
          selectedItems: {
              ...this.state.selectedItems,
              'certification-body': {
                  'level-2': [],
                  'level-3': [],
                  'level-4': [],
              },
              'inspection-body': {
                  'level-2': [],
                  'level-3': [],
                  'level-4': [],
              },
              'non-accredited-services': {
                  'level-2': [],
                  'level-3': [],
                  'level-4': [],
              }
          }
  }) }

    if(this.props.consultants.length){
      this.filterConsultants(this.state.selectedItems)
    }
    if (this.user.role === "Member") {
      this.props.fetchConsultantsInfos();
    }
  }

  componentDidUpdate(prevProps, prevState){
    var _this = this
    if(!prevProps.consultants.length && this.props.consultants.length){
      this.setState({
        consultants:_this.props.consultants
      })
    }


    if(prevProps.isLoading && !_this.props.isLoading){
      this.setState({
        consultants: _this.props.consultants
      })
    }

    if(prevState.validationFilter !== _this.state.validationFilter || prevState.filtersByOr.length !== _this.state.filtersByOr.length || !_this.state.filterApplied  ){
      
      this.filterConsultants(this.state.selectedItems)
      this.setState({filterApplied : true})
    }



  }

  isAnyActiveFilter(filter){
    return this.sumAllArrayLengths(filter) > 0;
  }

  sumAllArrayLengths(obj) {
    let total = 0;
  
    for (const key in obj) {
      const value = obj[key];
  
      // If the value is an array, add its length
      if (Array.isArray(value)) {
        total += value.length;
      }
      // If the value is an object, recurse into it
      else if (value && typeof value === 'object') {
        total += this.sumAllArrayLengths(value);
      }
    }
    return total;
  }


  handleExtract(option){
    if (!this.isAnyActiveFilter(this.state.selectedItems)){
      return this.props.getExportConsultantsList(option);
    }
    let filter = JSON.parse(JSON.stringify(this.state.selectedItems));

    if ( this.state.expertiseFilter['intervention-level'].length < 5 ) {
      Object.assign(filter['intervention-level'], { expertise: this.state.expertiseFilter['intervention-level'] });
    }
    if ( this.state.expertiseFilter.engineering.length < 5 ) {
      Object.assign(filter.engineering, { expertise: this.state.expertiseFilter.engineering });
    }
    if ( this.state.expertiseFilter.expertise.length < 5 ) {
      Object.assign(filter.expertise, { expertise: this.state.expertiseFilter.expertise });
    }
    if ( this.state.expertiseFilter.tools.length < 5 ) {
      Object.assign(filter.tools, { expertise: this.state.expertiseFilter.tools });
    }
    return this.props.getExportConsultantsList(option,filter);
  }

  setSort(data) {
    this.setState({
      sortBy:data
    })
  }

    setExpertiseFilter(field, value){

        let competencyGroup;
        if (field === 'certification-body') {
            competencyGroup = "certification-body"
        } else if (field === "inspection-body") {
            competencyGroup = "inspection-body"
        } else if (field === "non-accredited-services") {
            competencyGroup = "non-accredited-services"
        } else {
            competencyGroup = "general";
        }

      const sliderValue = {
          "general": ['basic', 'limited', 'intermediate', 'advanced', 'expert'],
          "certification-body": ["signatory under mentorship", "assessor under mentorship", "signatory", "assessor", "lead assessor"],
          "inspection-body": ["assessor under mentorship", "assessor", "lead assessor/technical manager"],
          "non-accredited-services": ["technical manager", "signatory", "assessor", "lead assessor"]
      };

    this.setState({
      expertiseFilter : {...this.state.expertiseFilter, [field]:sliderValue[competencyGroup].slice(value[0],value[1]+1)},
      filterApplied:false
    })

  }



  setFilterByOr(selectParent) {
    var list = _.cloneDeep(this.state.filtersByOr);
    if (this.state.filtersByOr.find(item => item === selectParent )) {
      list = list.filter(item => item !== selectParent);
    } else {
      list.push(selectParent);
    }
    this.setState({ filtersByOr: list });
  }

  selectItem(data) {
      var items = this.state.selectedItems;
      if (data && data.filter !== undefined) {
          items[data.filter][data.name] = data.value;
      } else if (data && data.name) {
          items[data.parent][data.name] = data.value;
      } else if (data && data.parent) {
          items[data.parent] = data.value;
      } else {
      };

      this.props.updateFilter(items);
      this.filterConsultants(items);
  }


  transformConsultants(consultants){



    const consultantsTransformed = _.map(consultants,(consultant)=>{
      consultant.content['information-consultant']['filiale-country'] = consultant.user.sageContent.filiale.country;
      consultant.content['information-consultant']['office'] = consultant.user.sageContent.filiale.city;

      consultant.content['information-consultant']['manager'] = "NA"
      if (consultant.user.sageContent.manager){
        consultant.content['information-consultant']['manager'] = consultant.user.sageContent.manager.sageContent.profile.firstName + " " + consultant.user.sageContent.manager.sageContent.profile.lastName ;
      }

      consultant.content.clients = consultant.clients
      return consultant
    })
    return consultantsTransformed
  }


  filterConsultants(inputItems){
    var _this = this
    var filtersByOr = this.state.filtersByOr;
    var filtredList = [];


    let consultants = _this.transformConsultants(_this.props.consultants); 

      let items = JSON.parse(JSON.stringify(inputItems));
      if (this.user.group === "aegis") {
          items['accreditation-body'] = {};
          items['accreditation-body']['level-2'] = items['certification-body']['level-2'].concat(items['inspection-body']['level-2'], items['non-accredited-services']['level-2']);
          items['accreditation-body']['level-3'] = items['certification-body']['level-3'].concat(items['inspection-body']['level-3'], items['non-accredited-services']['level-3']);
          items['accreditation-body']['level-4'] = items['certification-body']['level-4'].concat(items['inspection-body']['level-4'], items['non-accredited-services']['level-4']);

          delete items['certification-body'];
          delete items['inspection-body'];
          delete items['non-accredited-services'];
      }




    //FILTER BY OR
    _.forEach(items, function(parentItem, parentItemKey){
      if(Array.isArray(parentItem)){
        if(parentItem.length){
          consultants.forEach((consultant) => {
            
            var mapConsultant = consultant.content[parentItemKey]
            if (filtersByOr.find(i => i === parentItemKey.toString()) && _.intersection(mapConsultant, parentItem).length > 0 ) {
              return filtredList.push(consultant)
            }
          })
        }
      }else{
        _.forEach(parentItem, function(item, itemKey){
          if(item.length){
            consultants.forEach((consultant) => {
              var mapConsultant = consultant.content[parentItemKey]
              if(mapConsultant && Array.isArray(mapConsultant)){
                mapConsultant = _.map(mapConsultant, itemKey)
                if (filtersByOr.find(i => i === parentItemKey.toString()) && _.intersection(mapConsultant, item).length > 0 ) {
                  return filtredList.push(consultant)
                }
              } else {
                if(mapConsultant && Array.isArray(mapConsultant[itemKey])){
                  var arrayToTest = mapConsultant[itemKey]
                  if(typeof(mapConsultant[itemKey][0]) === 'object'){
                    arrayToTest = _.map(arrayToTest, 'name')
                  }
                  if (filtersByOr.find(i => i === parentItemKey.toString()) && _.intersection(arrayToTest, item).length > 0 ) {
                    return filtredList.push(consultant)
                  }
                } else {
                  if (filtersByOr.find(i => i === parentItemKey.toString()) && consultant.content[parentItemKey.toString()] && consultant.content[parentItemKey.toString()][itemKey.toString()]) {
                    if (item.indexOf(consultant.content[parentItemKey.toString()][itemKey.toString()]) !== -1 ) {
                      return filtredList.push(consultant)
                    }
                  }
                }
              }
            })
          }
        })
      }
    });
      
    //FILTER BY AND
    var results  = filtredList.length > 0 ? filtredList : _this.props.consultants ;
      
      var filters = {};

      

    Object.keys(items).forEach(item => {
      if(!filtersByOr.find(parent => parent === item )) {
        filters[item] = items[item];
      }
    })


      _.forEach(filters, function (parentItem, parentItemKey) {

      if(Array.isArray(parentItem)){
        if(parentItem.length){
          results = _.filter(results, function(consultant){
            var mapConsultant = consultant.content[parentItemKey]
              return _.intersection(mapConsultant, parentItem).length > 0 ;
          })
        }
      }else{
        _.forEach(parentItem, function(item, itemKey){
          if(item.length){
            results = _.filter(results, function(consultant){
              var mapConsultant = consultant.content[parentItemKey]
              if(mapConsultant && Array.isArray(mapConsultant)){
                mapConsultant = _.map(mapConsultant, itemKey)
                  return _.intersection(mapConsultant, item).length > 0
              } 
              if (itemKey === "environnement-domain"){
                mapConsultant = consultant.content[parentItemKey]["environnement-domain"][ parentItem["environnement-domain"] ]
                return(mapConsultant>0)
              }
              if (itemKey === "environnement-context") {
                const { "environnement-context": { Energy, Railway } } = consultant.content[parentItemKey];
                const energyMapConsultant = Energy[parentItem["environnement-context"][0]];
                const railwayMapConsultant = Railway[parentItem["environnement-context"][0]];
                return energyMapConsultant > 0 || railwayMapConsultant > 0;
              }
              else {
                if(mapConsultant && Array.isArray(mapConsultant[itemKey])){
                  var arrayToTest = mapConsultant[itemKey]
                  if(typeof(mapConsultant[itemKey][0]) === 'object'){
                    arrayToTest = _.map(arrayToTest, 'name')
                  }
                    return _.intersection(arrayToTest, item).length > 0
                } else {
                    if (consultant.content[parentItemKey.toString()] && consultant.content[parentItemKey.toString()][itemKey.toString()]) {
                      return item.indexOf(consultant.content[parentItemKey.toString()][itemKey.toString()]) !== -1 ;
                    }
                }
              }
            })
          }
        })
      }
    })


    if (this.state.selectedItems.tools.name.length > 0 && this.state.expertiseFilter.tools.length < 5){
      results = results.filter((consultant)=>{
        let tools = consultant.content.tools.filter((tool)=>{return this.state.selectedItems.tools.name.includes(tool.name)})
        return tools.some((tool)=>{return this.state.expertiseFilter.tools.includes(tool.expertise)})
      })
      
    }

    if ((this.state.selectedItems.engineering['engineering-skill'].length > 0 || 
          this.state.selectedItems.engineering['engineering-specialization'].length > 0) && 
          this.state.expertiseFilter.engineering.length < 5){
            results = results.filter((consultant)=>{

              if (!consultant.content.engineering){return false}
              let skills = consultant.content.engineering.filter((skill)=>{return this.state.selectedItems.engineering['engineering-skill'].includes(skill['engineering-skill']) 
                                                                            || this.state.selectedItems.engineering['engineering-specialization'].includes(skill['engineering-specialization']) 
                                                                    })
              return skills.some((skill)=>{return this.state.expertiseFilter.engineering.includes(skill.expertise)})
      })
      
    }


    if ((this.state.selectedItems['intervention-level']['intervention-type'].length > 0 || 
      this.state.selectedItems['intervention-level']['intervention-mission'].length > 0 ||
      this.state.selectedItems['intervention-level']['intervention-application'].length > 0) && 
      this.state.expertiseFilter['intervention-level'].length < 5){
        results = results.filter((consultant)=>{

          if (!consultant.content['intervention-level']){return false}
          let skills = consultant.content['intervention-level'].filter((skill)=>{return this.state.selectedItems['intervention-level']['intervention-type'].includes(skill['intervention-type']) 
                                                                        || this.state.selectedItems['intervention-level']['intervention-mission'].includes(skill['intervention-mission'])
                                                                        || this.state.selectedItems['intervention-level']['intervention-application'].includes(skill['intervention-application']) 
                                                                })
          return skills.some((skill)=>{return this.state.expertiseFilter['intervention-level'].includes(skill.expertise)})
      })
  
    }


    if ((this.state.selectedItems['expertise']['domain-competence'].length > 0 || 
      this.state.selectedItems['expertise']['domain-speciality'].length > 0 ||
      this.state.selectedItems['expertise']['domain-specificity'].length > 0) && 
      this.state.expertiseFilter['expertise'].length < 5){
        results = results.filter((consultant)=>{

          if (!consultant.content['expertise']){return false}
          let skills = consultant.content['expertise'].filter((skill)=>{return this.state.selectedItems['expertise']['domain-competence'].includes(skill['domain-competence']) 
                                                                        || this.state.selectedItems['expertise']['domain-speciality'].includes(skill['domain-speciality'])
                                                                        || this.state.selectedItems['expertise']['domain-specificity'].includes(skill['domain-specificity']) 
                                                                })
          return skills.some((skill)=>{return this.state.expertiseFilter['expertise'].includes(skill.expertise)})
      })
  
    }


      if (this.user.group === "aegis") {

          if ((
              this.state.selectedItems['certification-body']['level-2'].length > 0 ||
              this.state.selectedItems['certification-body']['level-3'].length > 0 ||
              this.state.selectedItems['certification-body']['level-4'].length > 0) &&
              this.state.expertiseFilter['certification-body'].length < 5) {
              results = results.filter((consultant) => {

                  if (!consultant.content['accreditation-body']) { return false }
                  let skills = consultant.content['accreditation-body'].filter((skill) => {
                      return skill['level-1'] === "Certification Body" && (this.state.selectedItems['certification-body']['level-2'].includes(skill['level-2'])
                          || this.state.selectedItems['certification-body']['level-3'].includes(skill['level-3'])
                          || this.state.selectedItems['certification-body']['level-4'].includes(skill['level-4']))
                  })
                  return skills.some((skill) => { return this.state.expertiseFilter['certification-body'].includes(skill.expertise) })
              })

          }


          if ((
              this.state.selectedItems['inspection-body']['level-2'].length > 0 ||
              this.state.selectedItems['inspection-body']['level-3'].length > 0 ||
              this.state.selectedItems['inspection-body']['level-4'].length > 0) &&
              this.state.expertiseFilter['inspection-body'].length < 3) {
              results = results.filter((consultant) => {

                  if (!consultant.content['accreditation-body']) { return false }
                  let skills = consultant.content['accreditation-body'].filter((skill) => {
                      return skill['level-1'] === "Inspection Body" && (this.state.selectedItems['inspection-body']['level-2'].includes(skill['level-2'])
                          || this.state.selectedItems['inspection-body']['level-3'].includes(skill['level-3'])
                          || this.state.selectedItems['inspection-body']['level-4'].includes(skill['level-4']))
                  })
                  return skills.some((skill) => { return this.state.expertiseFilter['inspection-body'].includes(skill.expertise) })
              })

          }

          if ((
              this.state.selectedItems['non-accredited-services']['level-2'].length > 0 ||
              this.state.selectedItems['non-accredited-services']['level-3'].length > 0 ||
              this.state.selectedItems['non-accredited-services']['level-4'].length > 0) &&
              this.state.expertiseFilter['non-accredited-services'].length < 4) {
              results = results.filter((consultant) => {

                  if (!consultant.content['accreditation-body']) { return false }
                  let skills = consultant.content['accreditation-body'].filter((skill) => {
                      return skill['level-1'] === "Non-accredited-services" && (this.state.selectedItems['non-accredited-services']['level-2'].includes(skill['level-2'])
                          || this.state.selectedItems['non-accredited-services']['level-3'].includes(skill['level-3'])
                          || this.state.selectedItems['non-accredited-services']['level-4'].includes(skill['level-4']))
                  })
                  return skills.some((skill) => { return this.state.expertiseFilter['non-accredited-services'].includes(skill.expertise) })
              })

          }
      }

    //filter by validation
    if (this.state.validationFilter === "validated"){
      results = _.filter(results, function(item){
        return item.validationInformation && item.validationInformation.validationStatus === "document_validation_status_validated";
      })
    }else if (this.state.validationFilter === "not validated"){
      results = _.filter(results, function(item){
        return !item.validationInformation || item.validationInformation.validationStatus !== "document_validation_status_validated";
      })
    }else{
      
    }


    this.setState({
      selectedItems:inputItems,
      consultants: _.uniqBy(results, '_id'),
    })
  };


  selectValidationFilter(value){
    if (value === "all"){
      this.setState({
        validationFilter: "all"
      })
    }
    else if (value === "validated") {
      this.setState({
        validationFilter: "validated"
      })
    }
    else {
      this.setState({
        validationFilter: "not validated"
      })      
    }
  }


  searchUpdated = (term) => {
    this.setState({searchTerm: term})
  }

  

  renderConsultants() {
    const KEYS_TO_FILTERS = ['user.sageContent.profile.lastName', 'user.sageContent.profile.firstName']
    var consultants = _.cloneDeep(this.state.consultants);

    if (this.state.searchTerm) {
      consultants = consultants.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
    }


    if (consultants && consultants.length) {
      if(this.state.sortBy === 'alphabetic'){
        consultants = _.sortBy(consultants, function(consultant){
          if(consultant.profile){
            return consultant.profile.lastName
          }
        })
      }
      if(this.state.sortBy === 'projects'){
        consultants = _.sortBy(consultants, function(consultant){
          return consultant.projects
        }).reverse()
      }
      if(this.state.sortBy === 'years of experience'){
        consultants = _.sortBy(consultants, function(consultant){
          let yearsExperiences = 0
          Object.keys(consultant.content.environnement['environnement-domain']).forEach(key => {
            const value = consultant.content.environnement['environnement-domain'][key];
            if(value){ yearsExperiences += parseFloat(value) }
          });
          return yearsExperiences
        }).reverse()
      }
      if(this.state.sortBy === 'completion'){
        consultants = _.sortBy(consultants, function(consultant){
          return consultant.progression.globalPercentage
        }).reverse()
      }

      return (
        <ConsultantList
          user={this.user}
          displayConsultants={consultants} 
          translate = {this.props.translate}
        />
      );
    }
  }

  renderAdmin = (expertises, interventionLevel , seniorityData) => {

    var _this = this

    return (
      <>
        <div className="dashboard-header">
          <h1 className="page-title">
            <span style={{ fontWeight: 'bold', color: '#000000' }}>{this.state.consultants.length ? this.state.consultants.length : 0}</span> {this.props.translate("Page.Consultant.title")}
          </h1>
        </div>
        <div key={"admin"} className="tiles">
          <div className="tile" style={{ width: 'calc(33% - 59px)', height: '240px' }}>
            {expertises.map(expertise => <div key={Date.now() + "-" + expertise.index} style={{ display: 'block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
              <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'rgb(68, 84, 96)', display: 'block' }}><ContainerTranslation id={['domain-competence'] + "." + [expertise.name]} /></span>
              <span style={{ fontSize: '14px', color: '#eb4f1e', marginBottom: '18px', display: 'block' }}>{expertise.count} consultants</span>
            </div>)}
          </div>
          <div className="tile" style={{ width: 'calc(33% - 59px)', height: '240px' }}>
            {interventionLevel.map(intervention => <div key={Date.now() + "-" + intervention.index} style={{ display: 'block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
              <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'rgb(68, 84, 96)', display: 'block' }}><ContainerTranslation id={['intervention-type'] + "." + [intervention.name]} /></span>
              <span style={{ fontSize: '14px', color: '#eb4f1e', marginBottom: '18px', display: 'block' }}>{intervention.count} consultants</span>
            </div>)}
          </div>
          <div className="tile" style={{ width: 'calc(33%)', padding: '0', height: '280px' }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" , height:"100%" }}>
            <SeniorityPyramid data={seniorityData}/>
            </div>
          </div>
        </div>
        <ConsultantSearch
          searchTerm={_this.state.searchTerm}
          searchUpdated={_this.searchUpdated}
          consultants={_this.state.consultants}
          initConsultants={_this.transformConsultants(_this.props.consultants)}
          filtersByOr={_this.state.filtersByOr}
          setFilterByOr={_this.setFilterByOr.bind(this)}
          selectedItems={_this.state.selectedItems}
          selectItem={_this.selectItem.bind(this)}
          setSort={_this.setSort.bind(this)}
          selectValidationFilter={_this.selectValidationFilter.bind(this)}
          setExpertiseFilter={_this.setExpertiseFilter.bind(this)}
          expertiseFilter={_this.state.expertiseFilter}
          handleExtract={_this.handleExtract.bind(this)}
        />
        <div className="page-container">
          {_this.renderConsultants()}
        </div>
      </>
    )
  }

  renderMember = () => {

    if (Object.keys(this.props.infos).length === 0) {return null}
    
    return (
      <>
        <div key={"member"} className="tiles">
          <div className="tile" style={{width: 'calc(33% - 59px)', height: '240px'}}>
            <div className="rates">
              <div className="rate">
              </div>
              <div className="rate">
                <span><span style={{color: '#eb4f1e'}}>{this.props.infos.filiales} </span> {this.props.translate("Page.Consultant.subsidiaries")}</span>
              </div>
            </div>
          </div>
          <div className="tile" style={{width: 'calc(33% - 59px)', height: '240px'}}>
            <div className="genders">
              <div className="gender">
                <i className="fas fa-male gender-icon"></i>
                <span>{Math.round(this.props.infos.males)} %</span>
              </div>
              <div className="gender">
                <i className="fas fa-female gender-icon"></i>
                <span>{Math.round(this.props.infos.females)} %</span>
              </div>
            </div>
          </div>
          {/* <div className="tile" style={{width: 'calc(33%)', padding:'0', height: '280px'}}>
            <HorizontalBarViz
              data={Object.entries(this.props.infos.seniority)}
            />
          </div> */}
        </div>
        <div className="page-container" style={{ marginBottom:'30px' , paddingTop:'15px' }}>
          <span>{this.props.translate("Page.Consultant.mapTitle")}</span>
          <Map data={this.props.infos.countries} label={this.props.translate("Page.Project.title")}/>
        </div>
      </>
    )
  }



  render() {
    
    if (this.props.consultants.length === 0) {return null}
    let expertises = []
    _.each(this.state.consultants, function(consultant){

      _.each(_.uniqBy(consultant.content.expertise , 'domain-competence' ), function(expertise){

        let foundExpertise = _.find(expertises, function(exp){return exp.name === expertise['domain-competence']})
        if(foundExpertise) {
          foundExpertise.count += 1 ;
        } else {
          if(expertise['domain-competence']){
            expertises.push({
              name:expertise['domain-competence'],
              count:1,
              consultant: consultant._id,
              index:expertises.length
            })
          }
        }
      })
    });

    expertises = _.orderBy(expertises, 'count').reverse()
    expertises = _.take(expertises, 5)

    let interventionLevel = []
    _.each(this.state.consultants, function(consultant){
      _.each(_.uniqBy(consultant.content['intervention-level'], 'intervention-type' ), function(intervention){
        let foundIntervention = _.find(interventionLevel, function(int){return int.name === intervention['intervention-type']})
        if(foundIntervention){
          foundIntervention.count += 1
        }else{
          if(intervention['intervention-type']){
            interventionLevel.push({
              name:intervention['intervention-type'],
              count:1,
              index:interventionLevel.length
            })
          }
        }
      })
    })
    interventionLevel = _.orderBy(interventionLevel, 'count').reverse()
    interventionLevel = _.take(interventionLevel, 5)

    let seniorityData = [
      {
        "seniority": this.props.translate("Page.Consultant.seniority.Junior"),
        "Energy": 0,
        "Railway": 0
      },
      {
        "seniority": this.props.translate("Page.Consultant.seniority.Medium"),
        "Energy": 0,
        "Railway": 0
      },
      {
        "seniority": this.props.translate("Page.Consultant.seniority.Confirmed"),
        "Energy": 0,
        "Railway": 0
      },
      {
        "seniority": this.props.translate("Page.Consultant.seniority.Senior"),
        "Energy": 0,
        "Railway": 0
      },
      {
        "seniority": this.props.translate("Page.Consultant.seniority.Expert"),
        "Energy": 0,
        "Railway": 0
      }
    ]

    if (this.user.role !== "Member") {
      let _this = this
      _.each(this.state.consultants, function(consultant){
        if(consultant.content && consultant.content.environnement){
          _.each(consultant.content.environnement['environnement-domain'], function(domain,key){

            if (domain && domain>0) {
              let seniorityIndex = Math.min(Math.floor(parseInt(domain) / 3), 4);
              if(domain >9 && domain <15){
                seniorityIndex = 3
              }
              if(domain >=15){
                seniorityIndex = 4
              }
              ;

              seniorityData[seniorityIndex][key] += 1;
              
            }
          })
        }
      })
    }



    return (
      <>
        {this.user.role !== "Member" ?
          this.renderAdmin(expertises, interventionLevel , seniorityData)
          :
          this.renderMember()
        }
      </>
    );
  }
}





function mapStateToProps(state) {
  return {
    consultants: state.consultant.consultants,
    infos: state.consultant.consultantsInfos,
    filter: state.filter.consultant
  };
}

function mapDispatchToProps(dispatch) { 

  return bindActionCreators({
  fetchConsultants, 
  fetchConsultantsInfos,
  readFilter,
  updateFilter,
  getExportConsultantsList 
}, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(Consultant));